export type LayoutVariant = "sidebar" | "minimal";

export const topHeaderHeights = {
  mobile: 80,
  desktop: 30,
  minimal: 0,
} as const;

export function isSubscribePage(pathname: string) {
  return pathname.startsWith("/subscribe");
}

export function isResetPasswordPage(pathname: string) {
  return pathname === "/reset-password";
}

export function isOnboardingPage(pathname: string) {
  return pathname === "/welcome";
}

export function isClaimProjectPage(pathname: string) {
  return pathname === "/claim-project";
}

export function isOAuthConsentPage(pathname: string) {
  return pathname === "/oauth/consent";
}

export function isGuestOnboardingPage(pathname: string) {
  return pathname === "/guest/welcome";
}

export function isWorkspacePage(pathname: string) {
  return pathname.startsWith("/workspace");
}

export function isAssetPage(pathname: string) {
  return pathname.startsWith("/create");
}
